<template>
    <section/>
</template>

<script>
import { formatCouponCode } from '@/helpers/CouponHelpers';
import CouponService from '@/services/coupons/CouponService';

export default {
    name: 'ReferenceFromAFriend',
    props: {
        code: {
            type: String,
            default: null,
        },
    },
    computed: {
        couponCode: {
            get() {
                return this.$store.getters['register/getCouponCode'];
            },
            set(code) {
                this.$store.commit('register/setCouponCode', code);
            },
        },
        friendCode: {
            get() {
                return this.$store.getters['register/getFriendCode'];
            },
            set(code) {
                this.$store.commit('register/setFriendCode', code);
            },
        },
    },
    mounted() {
        this.couponCode = formatCouponCode(this.code);
        this.validateCouponCode();
        if (this.$globalQueryParams?.cms === 'journey-coupon-homepage') this.$globalQueryParams.cms = null;
    },
    methods: {
        handleInvalidRedirect() {
            this.couponCode = null;
            this.$router.push({ name: '404' });
        },

        validateCouponCode() {
            localStorage.removeItem('urlCouponCode');
            if (this.$globalQueryParams?.cms || this.$route?.redirectedFrom?.includes('/v2')) localStorage.setItem('urlCouponCode', this.couponCode);
            CouponService.getCouponByCouponCode(this.couponCode)
                .then(response => {
                    if (response.data.properties.coupon_handle) localStorage.setItem('urlCouponCode', response.data.properties.coupon_handle);
                    else localStorage.setItem('urlCouponCode', this.couponCode);
                    this.friendCode = formatCouponCode(this.couponCode);
                    this.couponCode = formatCouponCode(response.data.properties.code);
                    this.$store.commit('register/setCouponProperties', response.data.properties);
                    if (this.$route?.redirectedFrom?.includes('/v2')) this.$globalQueryParams.pageVersion = 'v2';
                    this.$router.push({ name: 'home' });
                })
                .catch(error => {
                    console.error(error);
                    this.handleInvalidRedirect();
                });
        },
    },
};
</script>
